// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "软件项目管理",
      "tec": "于舜",
      "week": "1-12周",
      "add": "教学楼B座324能动"
    },
    {
      "sub": "软件工程",
      "tec": "马晟",
      "week": "1-12周",
      "add": "实训楼F座606信机"
    },
    {
      "sub": "能源电力工程与绿色低碳概论",
      "tec": "崔箫董香栾",
      "week": "5-12周",
      "add": "教学楼C座402管理"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "软件测试",
      "tec": "张楠",
      "week": "1-11周",
      "add": "教学楼C座110教务"
    },
    {
      "sub": "移动应用开发",
      "tec": "曾祥萍",
      "week": "1-12周",
      "add": "实训楼F座606信机"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "软件工程",
      "tec": "马晟",
      "week": "1-12周",
      "add": "实训楼F座606信机"
    },
    {
      "sub": "计算机网络",
      "tec": "张小瑞",
      "week": "1-12周",
      "add": "教学楼C座403管理"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "软件项目管理",
      "tec": "于舜",
      "week": "1-12周",
      "add": "实训楼F座402信息"
    },
    {
      "sub": "移动应用开发",
      "tec": "曾祥萍",
      "week": "1-12单周",
      "add": "实训楼F座606信机"
    },
    {
      "sub": "能源经济基础",
      "tec": "吕阳",
      "week": "1-8周",
      "add": "教学楼C座303教务"
    },
    {
      "sub": "科技文献检索",
      "tec": "张岚",
      "week": "1-4周",
      "add": "教学楼A座117电力"
    },
    0
  ],
  "5": [
    {
      "sub": "软件测试",
      "tec": "张楠",
      "week": "1-11单周",
      "add": "教学楼C座304教务"
    },
    {
      "sub": "计算机网络",
      "tec": "张小瑞",
      "week": "1-12周",
      "add": "实训楼F座303信息"
    },
    {
      "sub": "就业创业指导",
      "tec": "刘天宇",
      "week": "1-5周",
      "add": "教学楼C座113教务"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
